import LoginFirstSection from "../PageElements/RegistrationPageElements/LoginFirstSection"
import ServiceSection from "../PageElements/HomePageElements/ServiceSection"
import ConsultSection from "../PageElements/HomePageElements/ConsultSection"

export default function LoginPage() {
    return (
        <>
            <LoginFirstSection />
            {/* <ServiceSection /> */}
            {/* <ConsultSection /> */}
        </>
    )
}